<template>
  <div
    :class="{ 'read-more--open': open }"
    class="read-more"
  >
    <div class="read-more__content">
      <slot />
    </div>
    <button
      type="button"
      class="read-more__toggle"
      aria-hidden="true"
      @click="open = !open"
    >
      <span>{{ buttonText }}</span>
      <IconArrow class="icon icon--arrow" />
    </button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  more: {
    type: String,
    default: () => {
      const { t } = useI18n({ useScope: 'global' })
      return t('Read more')
    },
  },
  less: {
    type: String,
    default: () => {
      const { t } = useI18n({ useScope: 'global' })
      return t('Collapse')
    },
  },
})

const open = ref(false)

const buttonText = computed(() => {
  return open.value ? props.less : props.more
})
</script>

<style>
@import url("~layers/app/components/Ui/ReadMore.css");
</style>
